// Normalize the event object to be compatible with the Ember event system.
// This function is copied directly from ember-jquery-legacy addon: https://github.com/emberjs/ember-jquery-legacy/blob/master/addon/index.js
// The addon is using an older version of ember-cli-babel, which is incompatible with Ember 4

export function normalizeEvent(e) {
  if (e instanceof Event) {
    return e;
  }
  // __originalEvent is a private escape hatch of Ember's EventDispatcher to allow accessing `originalEvent` without
  // triggering a deprecation message.
  return e.__originalEvent || e.originalEvent;
}